export default function read (context, args, flags) {
  if (args.length === 0) return 'takes one argument [text file]'

  const folder = context.getWD()
  const target = args[0]

  if (folder[target] !== undefined && folder[target].type === 'txt') return folder[target].contents
  else return `no text file ${target}`
}



// WEBPACK FOOTER //
// ./src/natos/commands/read.js